import React, { Component } from 'react';
import { Button, Dropdown, Select } from 'antd';
import { Row, Col } from 'react-flexbox-grid';
import _ from 'lodash';
import { GoogleService } from '../../utils/GoogleService';

class OGoogleButton extends Component {
	constructor(props) {
		super(props);
		this.googleService = props.googleService;
		this.state = {
			container: props.container,
			accounts: [],
			webProperties: [],
			googleAccount: this.props.googleAccount,
			accountId: this.props.accountId,
			webPropertyId: this.props.webPropertyId,
			profileId: this.props.profileId
		};
	}

	componentWillReceiveProps(nextProps) {
		this.setState({ container: nextProps.container });
	}

	render() {
		const googleAccount = _.get(this.state.container, this.props.googleAccount, '');
		const accountId = _.get(this.state.container, this.props.accountId, '');
		const webPropertyId = _.get(this.state.container, this.props.webPropertyId, '');
		const profileId = _.get(this.state.container, this.props.profileId, '');

		return (
			<div>
				<h3>{this.props.label}</h3>
				<Row>
					<Col xs={12} style={{ paddingTop: 10 }}>
						<Button ref="button" type="primary" onClick={() => this.onSignIn()} {...this.props}>
							{this.props.buttonLabel}
						</Button>
					</Col>
				</Row>
				{googleAccount != '' && (
					<Row>
						<Col xs={12}>Signed In Account: {googleAccount}</Col>
					</Row>
				)}
				{this.state.accounts.length > 0 && (
					<Row>
						<Col xs={12} style={{ paddingTop: 10 }}>
							Website Account:
							<Select style={{ width: 200 }} onChange={value => this.onSelectAccount(value)}>
								{this.state.accounts.map(item => (
									<Select.Option key={item.id}>{item.name}</Select.Option>
								))}
							</Select>
						</Col>
					</Row>
				)}
				{this.state.webProperties.length > 0 && (
					<Row>
						<Col xs={12} style={{ paddingTop: 10 }}>
							Web Properties:
							<Select style={{ width: 200 }} onChange={value => this.onSelectWebProperties(value)}>
								{this.state.webProperties.map(item => (
									<Select.Option key={item.id}>{item.name}</Select.Option>
								))}
							</Select>
						</Col>
					</Row>
				)}
				{profileId != '' && this.state.view && (
					<Row>
						<Col xs={12} style={{ paddingTop: 10 }}>
							Selected View for Goal: {this.state.view.name}
						</Col>
					</Row>
				)}
			</div>
		);
	}

	async onSignIn() {
		let results = await this.googleService.getAccounts();
		this.value = results.result.username;
		this.state.accounts = results.result.items;

		const container = _.set(this.state.container, this.props.googleAccount, results.result.username);
		this.setState({ container });
	}

	async onSelectAccount(value) {
		let results = await this.googleService.getWebProperties(value);
		this.state.webProperties = results.result.items;

		const container = _.set(this.state.container, this.props.accountId, value);
		this.setState({ container });
	}

	async onSelectWebProperties(value) {
		item = this.state.webProperties.find(item => item.id == value);

		const accountId = _.get(this.state.container, this.props.accountId, '');

		let item = await this.googleService.getProfile(accountId, value, item.defaultProfileId);
		this.state.view = item.result;

		let container = _.set(this.state.container, this.props.webPropertyId, value);
		container = _.set(container, this.props.profileId, item.result.id);
		this.setState({ container });
	}

	focus() {
		this.refs.button.focus();
	}
}

export default OGoogleButton;



// WEBPACK FOOTER //
// ./src/components/commons/OGoogleButton.js